// project imports

// assets
import CloseIcon from '@mui/icons-material/Close';

import { Button, Grid, Typography, CardContent } from '@mui/material';

// project imports
import { StaffKecho } from 'types/kecho/staff-kecho';
import { reliefApi } from 'services/api';
import UIManager from 'core/UIManager';
import ModalCustom from 'components/Modal/ModalCustom';

// ===========================|| FIREBASE - REGISTER ||=========================== //
interface IProps {
    onClose: () => void;
    callback: any;
    relief?: StaffKecho;
}

const DeleteReliefModal = (props: IProps) => {
    const { onClose, callback, relief } = props;

    const handleDeleteRelief = async () => {
        if (relief?.id) {
            const { data } = await reliefApi.deleteRelief(relief?.id);
            if (data) {
                UIManager.showAlert({
                    message: 'Delete successfully!',
                    alert: {
                        color: 'success'
                    }
                });
                callback();
                onClose();
            }
        }
    };

    return (
        <ModalCustom
            onSave={handleDeleteRelief}
            onClose={onClose}
            onCancel={onClose}
            title="Confirm Delete"
            contentSave="Yes"
            contentCancel="Cancel"
        >
            <Grid item xs={12} style={{ padding: '20px 10px', textAlign: 'center' }}>
                <Typography variant="h4" gutterBottom component="div">
                    Are you sure you want to delete this draft?
                </Typography>
            </Grid>
        </ModalCustom>
    );
};

export default DeleteReliefModal;
